import React from 'react'
import * as Styled from './TabControl.styles'
import PropTypes from 'prop-types'

const TabControl = ({ active, label, elementRef, ...other }) => (
  <Styled.TabControl
    className={ active && 'active' }
    tabIndex={ active ? 0 : -1 }
    role='tab'
    aria-selected={ active }
    ref={ elementRef }
    { ...other }>
    {label && <div className='tab-label'>{label}</div>}
  </Styled.TabControl>
)

TabControl.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
}

export default TabControl
